// src/components/ShareableArticle/style.ts
import styled from 'styled-components';
import { Typography } from '@mui/material';

const BottomGap = styled.div`
  flex: 0 0 100px; /* fixed height, cannot collapse */
  width: 100%;
`;

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
`;

const Header = styled.div`
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: start;
  flex-direction: column;
`;

const HeaderTitle = styled(Typography)`
  && {
    font-weight: 700;
    font-size: 30px;
    color: #494949;
    font-family: Rubik;
  }

  @media (max-width: 539px) {
    && {
      font-size: 19px;
    }
  }
`;

const SubHeader = styled.div`
  display: flex;
  gap: 20px;
  align-items: baseline;
  margin-bottom: 0.3rem;

  @media (max-width: 539px) {
    gap: 8px;
  }
`;

const System = styled(Typography)`
  && {
    line-height: 2;
    font-size: 16px;
    color: #494949;
    font-weight: 400;
    font-family: Rubik;
  }
`;

const SystemImage = styled.img`
  width: 20px;
  border-radius: 50%;
  padding: 0;
  margin: 0;
  vertical-align: middle;
`;

const SystemText = styled.span`
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
`;

const Date = styled(Typography)`
  && {
    line-height: 2;
    font-size: 16px;
    color: #494949;
    font-weight: 400;
    font-family: Rubik;
  }
`;

const DateText = styled.span`
  display: inline-block;
  vertical-align: middle;
`;

const Version = styled(Typography)`
  && {
    line-height: 2;
    font-size: 16px;
    color: #494949;
    font-weight: 400;
    font-family: Rubik;
  }
`;

const VersionText = styled.span`
  display: inline-block;
  vertical-align: middle;
`;

const VerticalLine = styled.div`
  border-left: 1px solid #909090;
  height: 50%;
  vertical-align: bottom;
`;

const ScrollViewWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ScrollView = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  width: 100%;
  padding: 7px;
  box-shadow: 0px 0px 20px 0px #0000001A;
  border-radius: 16px;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 16px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 16px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
`;

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 25vh;
`;

const ContentWrapper = styled.div`
  width: 100%;
`;

const Article = styled.div`
  font-weight: 400;
  font-family: Rubik;
  font-size: 14px;

  @media (max-width: 539px) {
    && {
      font-size: xx-small;
    }
  }
`;

const styles = {
  BottomGap,
  Container,
  Header,
  HeaderContainer,
  HeaderTitle,
  SubHeader,
  System,
  SystemImage,
  SystemText,
  Date,
  DateText,
  Version,
  VersionText,
  VerticalLine,
  ScrollViewWrapper,
  ScrollView,
  LoadingContainer,
  ContentWrapper,
  Article,
};

export default styles;